@if (source !== '' && pdfData$ | ngrxPush; as pdfData) {
  <div class="sm:h-full sm:min-h-[500px]">
    <doc-viewer class="relative w-full sm:aspect-[2/3]" #viewer [src]="pdfData" disableDocumentHeadline="true" disableAttachments="true" disableTableOfContents="true"></doc-viewer>
  </div>
} @else {
  <div class="flex justify-center items-center">
    <dackl-empty-state size="XS">
      <h2 class="heading-3 mb-2">Keine Daten verfügbar</h2>
      <p>Keine Daten für dieses Produkt verfügbar</p>
    </dackl-empty-state>
  </div>
}
